/**
 * SA · Ops tab — Soft≠Live bridge only.
 *
 * Machine health focus lives once under Machine · list (?view=health).
 * This module must not paint a second Soft KPI grid or backend paths.
 */
import { useEffect } from "react";
import { html, F, Alert, go } from "./ui.js";

/** Canonical Live desk for platform machine-health focus. */
export const MACHINE_HEALTH_PATH = "/machine?view=health";
/** @deprecated alias — prefer MACHINE_HEALTH_PATH */
export const FLEET_HEALTH_PATH = MACHINE_HEALTH_PATH;

export function Ops() {
  useEffect(() => {
    go(MACHINE_HEALTH_PATH);
  }, []);

  return html`<${F}>
    <${Alert} tone="info" title="One Live machine-health desk"
      say="Platform and Machine share the same managed-machine list. Opening health focus — quiet units first."/>
    <button className="btn btn--go btn--sm" onClick=${() => go(MACHINE_HEALTH_PATH)}>
      Open Machine · health focus</button>
  <//>`;
}
